import { Route, Routes } from 'react-router-dom';
import Header from '../sections/Header/Header';
import HomePage from '../pages/HomePage/HomePage';
import CatalogPage from '../pages/CatalogPage/CatalogPage';
import CompanyPage from '../pages/CompanyPage/CompanyPage';
import DocumentationPage from '../pages/DocumentationPage/DocumentstionPage';
import NotFoundPage from '../pages/NotFoundPage/NotFoundPage';
import CartPage from '../pages/CartPage/CartPage';
import NewsPage from '../pages/NewsPage/NewsPage';
import ContactPage from '../pages/ContactPage/ContactPage';
import AuthPage from '../pages/AuthPage/AuthPage';
import Footer from '../sections/Footer/Footer';
import ProductPage from '../pages/ProductPage/ProductPage';
import { useActions } from '../../lib/hooks/useActions';
import { getS3Services } from '../../api/meta/getS3Services';
import { BrandsPage } from '../pages/BrandsPage/BrandsPage';
import AccountPage from '../pages/AccountPage/AccountPage';
import { PrivateRoute } from '../PrivateRoute/PrivateRoute';
import SchemePage from '../pages/SchemePage/SchemePage';
import FavoritesPage from '../pages/FavoritesPage/FavoritesPage';
import ScriptPage from '../pages/ScriptPage/ScriptPage';

export const AppContent = () => {
  const { setS3Host } = useActions();
  getS3Services().then((res) => res.s3_host && setS3Host(res.s3_host));

  return (
    <>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/catalog" element={<CatalogPage />} />
          <Route path="/company" element={<CompanyPage />} />
          <Route path="/documentation" element={<DocumentationPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/brands" element={<BrandsPage />} />
          <Route path="/product/:id" element={<ProductPage />} />
          <Route path="/login" element={<AuthPage />} />
          <Route path="/scheme/:id" element={<SchemePage />} />
          <Route path="/favorites" element={<FavoritesPage />} />
          <Route
            path="/W23n9NVfR3Ss/scriptPdfAnalize"
            element={<ScriptPage />}
          />
          <Route path="*" element={<NotFoundPage />} />
          {/* защищённые маршруты */}
          <Route element={<PrivateRoute />}>
            <Route path="/account" element={<AccountPage />} />
          </Route>
        </Routes>
      </main>
      <Footer />
    </>
  );
};
